module.exports = __webpack_public_path__ + "img/payment-detail.694da7b4.png";